import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
// redux
import { useDispatch, useSelector } from "react-redux";
import { fetchGroupById, updateGroup,fetchAllUserListSorted } from "../../../store/groupMgmt";
// kendo
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
// routes
import { USER_MANAGEMENT_GROUPS } from "../../../routes";
// component
import { GroupManagementForm } from "../form";
// image
import ArrorRightIcon from "../../../assets/common/arrao-right.svg";
import BackIcon from "../../../assets/communication/Back.svg";
import EditIcon from "../../../assets/common/edit_icon.svg";
// css
import "../group_management.css";
import { checkPermission,getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

export const GroupManagementDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const group_id = query.get("id");

  // state
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData,setFilteredData] = useState({});
  // redux
  const { group_details_loading, group_details, group_details_error,group_users_loading,group_users } =
    useSelector((state) => state.groupMgmt);

  // method
  const handleSaveGroup = (data) => {
    console.log("handleSaveGroup: ", data);
    dispatch(updateGroup({ id: group_id, data: data })).then(() => {
      setLoading(false);
      navigate(USER_MANAGEMENT_GROUPS);
    });
  };

  // useEffect
  useEffect(() => {
    if (group_id) {
      setLoading(true);
      dispatch(fetchGroupById(group_id));
      dispatch(fetchAllUserListSorted()).then((res)=>{
        setLoading(false);
      });
    }
  }, []);
  useEffect(()=>{
    if(group_details && group_users.length>0){
      const inactive_users = group_users.filter(x=>x?.is_active == false).map(x=>x?.username);
      // console.log(inactive_users);
      const users = group_details?.users.filter((x)=> !(inactive_users.includes(x?.username)));
      setFilteredData({...group_details,users});
    }
  },[group_details,group_users])
  const userPermissions = getUserPermission();
  const editPermission = checkPermission(userPermissions,"user_management.add_edit_group");
  const viewPermission = checkPermission(userPermissions,"user_management.access_group_management");
  return (
    <>
      {viewPermission ? (
      <div className="group-detail-body">
        {loading || group_details_loading ? (
          <Loader
            type="infinite-spinner"
            style={{
              display: "flex",
              alignItems: "center",
              width: "40px",
              margin: "auto",
              justifyContent: "center",
              height: "100vh",
            }}
          />
        ) : (
          <>
            <div className="group-detail-header">
              <div
                className="group-detail-group-div"
                onClick={() => navigate(USER_MANAGEMENT_GROUPS)}
              >
                <img src={BackIcon} className="group-detail-icon" />
                <span className="group-detail-label">Back</span>
              </div>
              {!isEdit &&  editPermission && (
                <div>
                  <Button
                    className="group-detail-edit-btn"
                    onClick={() => setIsEdit(true)}
                  >
                    <img src={EditIcon} style={{ verticalAlign: "middle" }} />
                    <span className="group-detail-edit-btn-label">Edit</span>
                    <img
                      src={ArrorRightIcon}
                      style={{ verticalAlign: "middle" }}
                    />
                  </Button>
                </div>
              )}
            </div>
            <div className="group-detail-content">
              <GroupManagementForm
                data={filteredData}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                setLoading={setLoading}
                submitForm={handleSaveGroup}
              />
            </div>
          </>
        )}
      </div>
    ):(
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />      
    )}
    </>
  );
};
